import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ATURAN_BAWAAN, IZIN_BUAT_KARTU_BAWAAN, IZIN_CARI_KARTU_BAWAAN } from "../lib/identitasNota";

/**
 * Aturan identitas pelanggan nota (batch N1) dari server — diambil SEKALI per
 * halaman, bukan tiap ketikan.
 *
 * Gagal = bawaan KETAT (Cabang & No HP wajib, nama B2B/USER bertempo dari
 * kartu), sama dengan server saat dokumen pengaturannya tidak ada: layar yang
 * lebih longgar dari server hanya memindahkan penolakan ke tombol Simpan.
 * Kunci izin tombol "+ Pelanggan baru" ikut dibaca dari server supaya tombol
 * memakai kunci yang SAMA dengan endpoint-nya (aturan #3 CLAUDE.md).
 */
export default function useAturanIdentitasNota() {
  const [aturan, setAturan] = useState(() => ({
    ...ATURAN_BAWAAN,
    izin_buat_kartu: IZIN_BUAT_KARTU_BAWAAN,
    izin_cari_kartu: IZIN_CARI_KARTU_BAWAAN,
  }));
  useEffect(() => {
    let batal = false;
    api.get("/sales/config/identitas-nota")
      .then(r => { if (!batal && r?.data) setAturan(a => ({ ...a, ...r.data })); })
      .catch(() => { /* tetap bawaan ketat */ });
    return () => { batal = true; };
  }, []);
  return aturan;
}
